/* These files are auto-generated, do not modify them. If you wish to modify certain assets, please use the sq-custom.css / sq-custom.js file */

function toggleFilter() {
  let x = document.querySelector(".sq-filter-main");
  x.classList.toggle("opening");
}
function toggleClass() {
  let y = document.querySelector(".sq-filter-main");
  y.classList.remove("opening");
}
function removeClass() {
  let z = document.querySelector(".sq-filter-main");
  z.classList.remove("opening");
}

window.sq = window.sq || {};

window.sq.initSearch = (store) => {
  store.search();
};

